
import { component } from '@/helpers/vueTyped';
import { getParentScopedStyleAttrs } from '@/helpers/utils';

interface InlineLoaderProps {
  strokeWidth?: number;
}

export default component<InlineLoaderProps>()({
  name: 'InlineLoader',

  functional: true,

  render(h, context) {
    const { strokeWidth } = context.props;

    return (
      <div
        ref={context.data.ref}
        on={context.listeners}
        {...{ directives: context.data.directives }}
        attrs={getParentScopedStyleAttrs(context.parent)}
        class={[context.data.class, 'inline-loader-container']}
      >
        <svg class='circular' viewBox='25 25 50 50'>
          <circle class='path' cx='50' cy='50' r='20' fill='none' stroke-width={strokeWidth || 2} stroke-miterlimit='10'/>
        </svg>
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-048f3c2b/InlineLoader.vue" });